import React, { useState, useEffect } from 'react';
import {
  Box, Typography, TextField, Button, Paper, Grid
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import DashboardLayout from '../../../Sidebar/DashboardLayout';
import axios from 'axios';
import './NiveauSettings.css';
import Chatbox from '../../../../commun/ChatBox';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const NiveauSettings = () => {
  const [niveaux, setNiveaux] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const userRole = localStorage.getItem('userType');

  useEffect(() => {
    const fetchNiveaux = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/settings/niveaux`);
        setNiveaux(res.data || []);
      } catch (err) {
        console.error("❌ Erreur récupération niveaux :", err);
      }
    };
    fetchNiveaux();
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...niveaux];
    updated[index][field] = field === 'recruited' || field === 'total'
      ? parseInt(value || 0, 10)
      : value;
    setNiveaux(updated);
  };

  const handleSave = async () => {
    try {
      await axios.post(`${API_BASE}/api/settings/niveaux`, niveaux);
      setIsEditing(false);
    } catch (err) {
      console.error("❌ Erreur sauvegarde niveaux :", err);
    }
  };

  return (
    <DashboardLayout>
      <div className="niveau-settings-wrapper">
        <Typography variant="h5" className="title">⚙️ Paramétrage des Niveaux (recrutés uniquement)</Typography>

        <Paper elevation={3} className="niveau-settings-card">
          {niveaux.map((niveau, index) => (
            <Grid container spacing={2} className="niveau-row" key={index}>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Nom du niveau"
                  variant="outlined"
                  value={niveau.label}
                  disabled={!isEditing}
                  onChange={(e) => handleChange(index, 'label', e.target.value)}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Seuil Recrutés"
                  type="number"
                  variant="outlined"
                  value={niveau.recruited || 0}
                  disabled={!isEditing}
                  onChange={(e) => handleChange(index, 'recruited', e.target.value)}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Couleur"
                  variant="outlined"
                  value={niveau.color}
                  disabled={!isEditing}
                  onChange={(e) => handleChange(index, 'color', e.target.value)}
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
          ))}

          <Box className="niveau-actions" mt={3} textAlign="right">
            {isEditing ? (
              <Button variant="contained" color="primary" startIcon={<SaveIcon />} onClick={handleSave}>
                Enregistrer
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>
                Modifier
              </Button>
            )}
          </Box>
        </Paper>
      </div>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </DashboardLayout>
  );
};

export default NiveauSettings;
